import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetPatientModel } from "@factory/model/query-model-patient";
import { patientFormDefault } from "./form.default";
import { PatientFormSchema } from "./form.rule";

export const useFormDefaultPatient = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetPatientModel | undefined) => {
    return !cachedValue
      ? patientFormDefault
      : ({
          tenant: cachedValue.tenant,
          firstName: cachedValue.first_name,
          middleName: cachedValue.middle_name,
          lastName: cachedValue.last_name,
          birthday: cachedValue.birthday,
          gender: cachedValue.gender,
          address: cachedValue.address,
          email: cachedValue.email,
          mobileNumber: cachedValue.mobile_number,
          isTakingMedication: Boolean(cachedValue.is_taking_medication),
          medicationDetails: cachedValue.medication_details,
          hasAllergies: Boolean(cachedValue.has_allergies),
          allergyDetails: cachedValue.allergy_details,
          hasMedicalConditions: Boolean(cachedValue.has_medical_conditions),
          medicalConditionDetails: cachedValue.medical_conditon_details,
          wasRecentlyUnwell: Boolean(cachedValue.was_recently_unwell),
          unwellDetails: cachedValue.unwell_details,
          otherMedicalConditions: cachedValue.other_medical_conditions,
        } as PatientFormSchema);
  };

  return {
    getDefault,
  };
};
